import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import apiConfig from '../../../apiConfig';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
const EditCategory = () => {
  const token = localStorage.getItem('authToken');
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { category } = location.state;


  const [formData, setFormData] = useState({
    name: category.name,
    status: category.status,
    images: null, 
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };


  const handleImageChange = (e) => {
    setFormData({
      ...formData,
      images: e.target.files[0] 
    });
  };


  const handleUpdate = async (event) => {
    event.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('images', formData.images);


    try {
     
      const response = await axios.put(
        `${apiConfig.baseUrl}${apiConfig.updateCategory}/${id}`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        }
      );

    
      setShowModal(true);
    } catch (error) {
      console.error("Error updating category:", error);
    
    }
  };

  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    navigate(`/admin/ViewCategory`);
  };

  const handleCancel = () => {
    navigate(`/admin/ViewCategory`);
  };

  return (
    <div>
      <h2>Edit Category</h2>
      <form onSubmit={handleUpdate} style={styles.form}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            style={styles.input}
            required 
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Status:</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleInputChange}
            style={styles.select}
           
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Image:</label>
          <input
            type="file"
            name="images"
            onChange={handleImageChange}
            style={styles.input}
            accept="image/*"
          />
        </div>
        <button type="submit" style={styles.button}>Update Category</button>
        <button type="button" style={{marginLeft:20}} className="btn btn-danger" onClick={handleCancel}>Cancel</button>
      </form>

    
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Product Updated</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Product <strong>{formData.name}</strong> has been successfully updated.</p>
     
        </Modal.Body>
        <Modal.Footer>
          <Button  variant="secondary" onClick={closeModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};



  const styles = {
    form: {
      maxWidth: '600px',
      margin: '0 auto',
      padding: '20px',
      border: '1px solid #ccc',
      borderRadius: '8px',
      background: '#f9f9f9',
    },
    formGroup: {
      marginBottom: '15px',
    },
    label: {
      display: 'block',
      marginBottom: '5px',
      fontWeight: 'bold',
    },
    input: {
      width: '100%',
      padding: '8px',
      fontSize: '1rem',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxSizing: 'border-box',
    },
    select: {
      width: '100%',
      padding: '8px',
      fontSize: '1rem',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxSizing: 'border-box',
      background: '#fff',
      cursor: 'pointer',
    },
    button: {
      background: '#007bff',
      color: '#fff',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '1rem',
    },
  };

export default EditCategory;
